import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-bd-search',
  templateUrl: './bd-search.component.html',
  styleUrls: ['./bd-search.component.css']
})
export class BdSearchComponent {

  searchText: string = '';
  @Output() searchTextChanged = new EventEmitter<string>();

  constructor() {}

  emitSearchText(): void {
    this.searchTextChanged.emit(this.searchText);
  }

  clearSearchText(): void {
    this.searchText = '';
    this.emitSearchText();
  }
}